import React, { Component, ReactElement, createRef, RefObject } from "react";
import { classNames, } from ".";

interface Props {
    onDismiss?: () => void; // important! this handler must contain e.stopPropagation()
    dismissOnClick?: boolean; // should the dropdown close when clicked *within*
    items?: React.ReactNode;

    children?: React.ReactNode;
}

export type { Props as DropdownProps };

export class Dropdown extends Component<Props, {}> {
    private _ref: RefObject<HTMLUListElement>;

    constructor(props: Props) {
        super(props);

        this._ref = createRef();
        this._handleDocumentClick = this._handleDocumentClick.bind(this);
    }

    public render(): ReactElement {
        const { items, children, } = this.props;

        const css = classNames([
            "dropdown-menu",
            "show",
            "__splitbuttonmenu__"
        ]);

        return (
            <ul className={css} ref={this._ref}>
                {items}
                {children}
            </ul>
        );
    }

    public componentDidMount(): void {
        document.addEventListener("click", this._handleDocumentClick);
    }

    public componentWillUnmount(): void {
        document.removeEventListener("click", this._handleDocumentClick);
    }

    // the dropdown will always close when an external element is clicked,
    // like the <body> or anything outside of its <ul> container
    public _handleDocumentClick(e: any): void {
        const { onDismiss, dismissOnClick, } = this.props;

        const target = e.target;
        const ref = this._ref.current;

        // if target is missing from _ref -- if target
        // is not a child of _ref -- we'll fire the dismiss event
        // this means that if we click inside the dropdown <ul> and
        // dismissOnClick is false, we'll stay open
        if (ref && ref.contains(target) && !dismissOnClick) {
            return;
        }

        onDismiss && onDismiss();
    }
}
